import OnDemandDevelopers from "../on-demand-developers";
import ProjectByEquity from "../project-by-equity";
import FullProjectDevelopment from "../full-project-development";
import WhatServices from "../what-services";
import Confirmation from "../confirmation";
import NavBar from "../nav-bar";
// import Intro from "../Intro";
import OurServices from "../our-services";
// import SeeOurWork from "../see-our-work";
// import ImpactAcrossIndustries from "../impact-across-industries";
// import WhatMakeUsDifferent from "../what-make-us-different";
// import WhatOurClientSays from "../what-our-client-says";
// import MeetOurTeam from "../meet-our-team";
// import AboutUs from "../about-us";
import Grid from "@mui/material/Grid/Grid";
import {CustomLabelMediumBold, CustomLabelMediumRegular} from "../common/CustomLabel";
import Box from "@mui/material/Box/Box";
import IPHONE151 from "../../assets/images/iPhone 15 Pro-1.png";
import ContactUs from "../contact-us";
import Footer from "../footer";
import React, {useRef, useState} from "react";
// import {useMediaQuery} from "@mui/material";
// import createTheme from "@mui/material/styles/createTheme";
import IntroDetails from "../intro-details";
// import WorkDetails from "../work-details";
// import PROJECT1 from "../../assets/images/project_1.png";
// import PROJECT2 from "../../assets/images/project2.png";
// import PROJECT3 from "../../assets/images/project3.png";
// import { useNavigate} from "react-router-dom"
import SERVICES_BANNER from "../../assets/images/services-banner.png";
import ServicesOnDemandDevelopers from "./services-on-demand-developers";
import ServicesFullProjectDevelopment from "./services-full-project-development";
import ServicesProjectByEquity from "./services-project-by";
import DevelopmentProcess from "./services-our-development-process";
import MaintenanceOffer from "./services-maintenance-offer";
import ServicesAreasExpertise from "./services-areas-expertise";
import { Helmet } from 'react-helmet';

// const theme = createTheme({
//     breakpoints: {
//         values: {
//             xs: 0,
//             sm: 710,
//             md: 950,
//             lg: 1300,
//             xl: 1350,
//         },
//     },
// });



const Service = () => {

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [showFullProject, setShowFullProject] = useState(false);
    const [showOnDemandDevelopers, setShowOnDemandDevelopers] = useState(false);
    const [showProjectByEquity, setShowProjectByEquity] = useState(false);
    const [showWhatServices, setShowWhatService] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    // let navigate = useNavigate();

    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const testimonalsRef = useRef(null);
    const partnersRef = useRef(null);
    const contactUsRef = useRef(null);


    // const UI = {
    //     title: "UI/UX Design",
    //     description: "We create user-friendly interfaces and engaging experiences for your website or app, ensuring it's easy to navigate and leaves a lasting impression on your audience. Our meticulous attention to detail ensures that every aspect of the design enhances usability and reflects your brand identity.",
    //     work: [
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT3,
    //             title: "TechSavvy Education Portal",
    //             description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         }
    //     ]
    // }


    // const FrontEnd = {
    //     title: "Frontend Development",
    //     description: "We create user-friendly interfaces and engaging experiences for your website or app, ensuring it's easy to navigate and leaves a lasting impression on your audience. Our meticulous attention to detail ensures that every aspect of the design enhances usability and reflects your brand identity.",
    //     work: [
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT3,
    //             title: "TechSavvy Education Portal",
    //             description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         }
    //     ]
    // }


    // const Backend = {
    //     title: "Backend Development",
    //     description: "We handle the technical side of things, building the functionality that powers your website or app, ensuring it runs smoothly and seamlessly integrates with other systems. Our expertise in backend development ensures robust performance, scalability, and security for your digital platform.",
    //     work: [
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT3,
    //             title: "TechSavvy Education Portal",
    //             description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         }
    //     ]
    // }


    // const MobileApp = {
    //     title: "Mobile App Development",
    //     description: "We develop mobile apps that keep your audience engaged on the go, delivering seamless experiences across iOS and Android platforms. From concept to launch, we prioritize user experience and functionality to ensure your app stands out in a crowded marketplace.",
    //     work: [
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT3,
    //             title: "TechSavvy Education Portal",
    //             description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         }
    //     ]
    // }


    // const SoftwareDevelopment = {
    //     title: "Software Development",
    //     description: "We create custom software solutions tailored to your unique business needs, streamlining processes and helping you achieve your goals more efficiently. Our technical skills and agile approach to development allows us to adapt to evolving requirements and deliver solutions that drive tangible results.",
    //     work: [
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT3,
    //             title: "TechSavvy Education Portal",
    //             description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         }
    //     ]
    // }


    // const WebDevelopment = {
    //     title: "Web Development",
    //     description: "From dynamic websites to custom features, we build online experiences that captivate your audience and drive results for your business. Our collaborative approach ensures that your website not only looks great but also meets your business objectives and exceeds user expectations.",
    //     work: [
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT3,
    //             title: "TechSavvy Education Portal",
    //             description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         }
    //     ]
    // }


    // const CloudServices = {
    //     title: "Cloud Services",
    //     description: "We leverage cloud technology to host and manage your online presence, providing reliability, scalability, and security for your website or app. Our expertise in cloud services ensures seamless integration, allowing you to focus on growing your business while we handle the technical infrastructure.",
    //     work: [
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT3,
    //             title: "TechSavvy Education Portal",
    //             description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         }
    //     ]
    // }


    // const onClickService=(e)=>{
    //     navigate('/service-details')
    // }

    return (
        <Grid style={{width: "100vw", height: "100vh", overflowX: "hidden",}}>
            <Helmet>
                    <title>Services - OSTRYX</title>
                    <meta name="url" content="https://ostryx.com/services" />
                    <link rel="canonical" href="https://ostryx.com/services" />
                    <meta name="title" content="Services - OSTRYX" />
                    <meta name="description" content="Services offered by OSTRYX." />
                    <meta name="keywords" content="OSTRYX, services" />
                    <meta property="og:title" content="Services - OSTRYX" />
                    <meta property="og:description" content="Services offered by OSTRYX." />
            </Helmet>

            {
                showOnDemandDevelopers && <OnDemandDevelopers setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                                              setShowConfirmation={setShowConfirmation}
                />
            }

            {
                showProjectByEquity && <ProjectByEquity setShowProjectByEquity={setShowProjectByEquity}
                                                        setShowConfirmation={setShowConfirmation}/>
            }


            {
                showFullProject && <FullProjectDevelopment setShowFullProject={setShowFullProject}
                                                           setShowConfirmation={setShowConfirmation}/>
            }


            {
                showWhatServices &&
                <WhatServices setShowWhatService={setShowWhatService} setShowFullProject={setShowFullProject}
                              setShowProjectByEquity={setShowProjectByEquity}
                              setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            }


            {
                showConfirmation && <Confirmation setShowConfirmation={setShowConfirmation}/>
            }
            <Grid sx={{
                width: "100%",
                minHeight: "480px",
                maxHeight: "120vh",
                position: 'relative',
                // height: {xs: '100vh', md: '80vh'},
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url(${SERVICES_BANNER})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    zIndex: 0
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(to top, rgb(0, 0, 0), transparent)',
                    zIndex: 1
                }
            }}>
                <Box sx={{ position: 'relative', zIndex: 2 }}>
                    <NavBar 
                        isMenuClicked={isMenuClicked}
                        serviceRef={serviceRef}
                        portfolioRef={portfolioRef}
                        testimonalsRef={testimonalsRef}
                        partnersRef={partnersRef}
                        setIsMenuClicked={setIsMenuClicked}
                        contactUsRef={contactUsRef}
                        setShowWhatService={setShowWhatService}
                    />

                    <IntroDetails 
                        title={"Premium Software Development Services USA"}
                        description={<span>Your business is unique, and your software solution should be too. 
                                    We offer <b>Custom Software Development Services</b> designed around your specific needs — 
                                    whether you need <b>on-demand developers </b> or a <b>full project development team.</b>
                                    For struggling startups and innovators, we offer <b>Project-by-Equity Partnerships</b>, 
                                    where you can tap into our technical expertise in exchange for a small equity share, 
                                    aligning our success with yours.</span>}
                        tag={"Let’s Build Something Great together!"}

                    />
                </Box>
            </Grid>
            
            <ServicesOnDemandDevelopers  setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            
            <ServicesFullProjectDevelopment setShowFullProject={setShowFullProject}/>

            <ServicesProjectByEquity setShowProjectByEquity={setShowProjectByEquity}/>

            <DevelopmentProcess/>

            <MaintenanceOffer/>

            <ServicesAreasExpertise/>

            {/* <Grid item xs={12} container
                  justifyContent={"center"}
                  sx={{
                      marginTop: {xs: "0px", md: "-10px"},
                      padding: {xs: '0px 0px', sm: "12px 0px", md: '12px 20px', lg: "12px 50px", xl: "12px 60px"}
                  }}>
                <Grid item xs={11} lg={12}>
                    <WorkDetails {...UI} type={1} onClick={onClickService}/>
                </Grid>


                <Grid item xs={11} lg={12}>
                    <WorkDetails {...FrontEnd} type={1} onClick={onClickService}/>
                </Grid>


                <Grid item xs={11} lg={12}>
                    <WorkDetails {...Backend} type={1} onClick={onClickService}/>
                </Grid>


                <Grid item xs={11} lg={12}>
                    <WorkDetails {...MobileApp} type={1} onClick={onClickService}/>
                </Grid>

                <Grid item xs={11} lg={12}>
                    <WorkDetails {...SoftwareDevelopment} type={1} onClick={onClickService}/>
                </Grid>

                <Grid item xs={11} lg={12}>
                    <WorkDetails {...WebDevelopment} type={1} onClick={onClickService}/>
                </Grid>

                <Grid item xs={11} lg={12}>
                    <WorkDetails {...CloudServices} type={1} onClick={onClickService}/>
                </Grid>
            </Grid> */}
            <OurServices serviceRef={serviceRef} setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                         setShowWhatService={setShowWhatService}
                         setShowFullProject={setShowFullProject}
                         setShowProjectByEquity={setShowProjectByEquity}/>


            <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}, px :{ xs: 1, md: 5}}} justifyContent={"center"}>

                <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                    <CustomLabelMediumBold text={"Discuss Your Project with #1 Software Development Company USA "} color={"#5E17EB"}/>
                </Grid>

                <Grid item container xs={10} style={{marginTop: "5px"}} justifyContent={"center"}>
                    <CustomLabelMediumRegular normal={false}
                                              text={"Got an Idea? Let’s Build It Together — Contact Us for Expert Development Solutions.  "}
                    />
                </Grid>


                <Grid item container xs={12} justifyContent={"space-between"}
                      sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "20px", lg: "60px"}}}>


                    <Grid item xs={12} lg={4.8}
                          sx={{maxHeight: "100%", width: "100%", padding: "0px", position: "relative"}}>
                        <Box component={"img"} src={IPHONE151} alt={"OSTRYX"}
                             sx={{height: {lg: "100%"}, width: {xs: "100%", lg: "100%", xlg: "auto"}}}/>
                    </Grid>

                    <ContactUs setShowConfirmation={setShowConfirmation}/>


                </Grid>

                <div ref={contactUsRef} tabIndex={0}></div>

            </Grid>


            <Footer/>

        </Grid>
    )
}

export default Service;
